import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { ReactQueryProvider } from '../web/ReactQueryProvider';
import { ApiClientContextProvider } from './contexts/apiClient';
import { ErrorProvider } from './contexts/errorMessage';
import { ScheduleMeetingRouter } from './ScheduleMeetingRouter';
import './styles/global-styles.less';

document.addEventListener('DOMContentLoaded', () => {
	configure({ enforceActions: 'never' });

	const root = createRoot(document.getElementById('react-root'));
	root.render(
		<ReactQueryProvider>
			<ApiClientContextProvider>
				<ErrorProvider>
					<ScheduleMeetingRouter />
				</ErrorProvider>
			</ApiClientContextProvider>
		</ReactQueryProvider>
	);
});
